
import { PriceData } from './types';

export function calculateMinPrice(dateData: PriceData[]): number {
  const prices = dateData.map(item => item.price);
  return Math.min(...prices);
}

export function calculateWeightedAverage(dateData: PriceData[]): number {
  // Calculate weighted average
  // Group by location and calculate weight based on frequency of data points per location
  const locationPriceMap = new Map<string, number[]>();
  dateData.forEach(item => {
    if (!locationPriceMap.has(item.location)) {
      locationPriceMap.set(item.location, []);
    }
    locationPriceMap.get(item.location)!.push(item.price);
  });
  
  let totalWeightedPrice = 0;
  let totalWeight = 0;
  
  locationPriceMap.forEach((locationPrices, location) => {
    const locationAvgPrice = locationPrices.reduce((sum, price) => sum + price, 0) / locationPrices.length;
    const weight = locationPrices.length; // Weight by number of data points from this location
    
    totalWeightedPrice += locationAvgPrice * weight;
    totalWeight += weight;
  });
  
  return totalWeight > 0 ? totalWeightedPrice / totalWeight : 0;
}
